import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import InputNumber from 'modules/_shared/components/InputNumber';

import { IncentiveOfferSellerParticipationLimits } from 'modules/incentivesMarket/types';

import SellerLimitsControls from '../SellerLimitsControls';

type BuyOfferUnitsSectionProps = {
  sharesToTransfer: number;
  sharesToTransferLabel: string;
  sharesToTransferInfo?: string;
  sellerParticipationLimits: IncentiveOfferSellerParticipationLimits;
  unitPrice: number;
  /* eslint-disable-next-line no-unused-vars */
  onChangeSharesToTransfer: (value: number) => void;
  /* eslint-disable-next-line no-unused-vars */
  onChangeAllowSellAll: (allowSellAll: boolean) => void;
  /* eslint-disable-next-line no-unused-vars */
  onChangeSellerLimit: (
    field: keyof IncentiveOfferSellerParticipationLimits,
    value: number
  ) => void;
};

const BuyOfferUnitsSection: FC<BuyOfferUnitsSectionProps> = ({
  sharesToTransfer,
  sharesToTransferLabel,
  sharesToTransferInfo,
  sellerParticipationLimits,
  unitPrice,
  onChangeSharesToTransfer,
  onChangeAllowSellAll,
  onChangeSellerLimit,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <div className="mb-4">
        <h6 className="overline-title text-soft mb-2">
          {t('IncentivesMarketBuyOfferTotalUnits')}
        </h6>
        <p className="text-soft fs-13px mb-3">
          {sharesToTransferInfo || t('IncentivesMarketBuyOfferTotalUnitsDescription')}
        </p>
        <div className="row">
          <div className="col-md-6">
            <InputNumber
              id="shares-to-transfer-input"
              label={sharesToTransferLabel}
              value={sharesToTransfer}
              decimalScale={2}
              onChange={onChangeSharesToTransfer}
              required
            />
          </div>
        </div>
      </div>

      <hr />

      <SellerLimitsControls
        variant="BUY"
        sellerParticipationLimits={sellerParticipationLimits}
        sharesToTransfer={sharesToTransfer}
        unitPrice={unitPrice}
        onChangeAllowSellAll={onChangeAllowSellAll}
        onChangeSellerLimit={onChangeSellerLimit}
      />
    </>
  );
};

export default BuyOfferUnitsSection;
